import {Component} from '@angular/core';
/**
 * \@title Basic radios
 */
export class RadioOverviewExample {static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'radio-overview-example',
  templateUrl: 'radio-overview-example.html',
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function RadioOverviewExample_tsickle_Closure_declarations() {
/** @type {?} */
RadioOverviewExample.decorators;
/**
 * @nocollapse
 * @type {?}
 */
RadioOverviewExample.ctorParameters;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
